"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _styles = require("@material-ui/core/styles");

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _withThemeProps = _interopRequireDefault(require("../withThemeProps"));

var themeSettings = {
  name: 'SxChipColored'
};
var useStyles = (0, _styles.makeStyles)({
  root: function root(_ref) {
    var backgroundColor = _ref.backgroundColor,
        color = _ref.color;
    return {
      color: color,
      backgroundColor: backgroundColor
    };
  },
  clickable: {
    '&:hover, &:focus': {
      backgroundColor: function backgroundColor(_ref2) {
        var _backgroundColor = _ref2.backgroundColor;
        return (0, _colorManipulator.emphasize)(_backgroundColor, 0.08);
      }
    },
    '&:active': {
      backgroundColor: function backgroundColor(_ref3) {
        var _backgroundColor2 = _ref3.backgroundColor;
        return (0, _colorManipulator.emphasize)(_backgroundColor2, 0.12);
      }
    }
  },
  deletable: {
    '&:focus': {
      backgroundColor: function backgroundColor(_ref4) {
        var _backgroundColor3 = _ref4.backgroundColor;
        return (0, _colorManipulator.emphasize)(_backgroundColor3, 0.08);
      }
    }
  },
  avatar: {
    backgroundColor: function backgroundColor(_ref5) {
      var avatarBackgrounColor = _ref5.avatarBackgrounColor;
      return avatarBackgrounColor;
    },
    color: function color(_ref6) {
      var avatarColor = _ref6.avatarColor;
      return avatarColor;
    }
  },
  icon: {
    color: function color(_ref7) {
      var _color = _ref7.color;
      return _color;
    }
  },
  deleteIcon: {
    color: function color(_ref8) {
      var deleteIconColor = _ref8.deleteIconColor;
      return deleteIconColor;
    },
    '&:hover': {
      color: function color(_ref9) {
        var deleteIconColor = _ref9.deleteIconColor;
        return (0, _colorManipulator.fade)(deleteIconColor, 0.4);
      }
    }
  }
}, themeSettings);
/**
 * Vsetky property okrem `color` su zhodne s `@aterial-ui/core/Chip`.
 *
 * @component
 */

var ChipColored = function ChipColored(_ref10) {
  var parentBgColor = _ref10.color,
      rest = (0, _objectWithoutProperties2.default)(_ref10, ["color"]);
  var theme = (0, _styles.useTheme)();

  var stylesProps = _react.default.useMemo(function () {
    var backgroundColor = parentBgColor || (theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700]);
    var color = theme.palette.getContrastText(backgroundColor);
    var deleteIconColor = (0, _colorManipulator.fade)(color, 0.26);
    var avatarBackgrounColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.1);
    var avatarColor = theme.palette.getContrastText(avatarBackgrounColor);
    return {
      backgroundColor: backgroundColor,
      color: color,
      deleteIconColor: deleteIconColor,
      avatarBackgrounColor: avatarBackgrounColor,
      avatarColor: avatarColor
    };
  }, [parentBgColor, theme]);

  var classes = useStyles(stylesProps);
  return /*#__PURE__*/_react.default.createElement(_Chip.default, (0, _extends2.default)({}, rest, {
    classes: {
      root: classes.root,
      clickable: classes.clickable,
      deletable: classes.deletable,
      avatar: classes.avatar,
      icon: classes.icon,
      deleteIcon: classes.icon
    }
  }));
};

process.env.NODE_ENV !== "production" ? ChipColored.propTypes = {
  /**
     * CSS color string.
     */
  color: _propTypes.default.string
} : void 0;
ChipColored.displayName = 'ChipColored';

var _default = (0, _withThemeProps.default)(themeSettings)(ChipColored);

exports.default = _default;